/**
 * Custom JavaScript - Focal Theme
 * --------------------------------
 * Ajoutez ici vos scripts personnalisés.
 * Exemples utiles :
 *
 * // Réagir quand une variante change
 * document.addEventListener('variant:changed', (e) => {
 *   const variant = e.detail.variant;
 *   console.log("Variante sélectionnée :", variant);
 * });
 *
 * // Réagir quand un article est ajouté au panier
 * document.addEventListener('variant:added', (e) => {
 *   const variant = e.detail.variant;
 *   console.log("Ajouté au panier :", variant);
 * });
 *
 * // Réagir quand le panier est mis à jour
 * document.addEventListener('cart:updated', (e) => {
 *   const cart = e.detail.cart;
 *   console.log("Panier mis à jour :", cart);
 * });
 */

// Exemple vide prêt à l'emploi
document.addEventListener('DOMContentLoaded', () => {
  console.log("custom.js chargé");
  // 👉 Ajoute ton code perso ici
});
